import { PaymentMethod } from './types/PaymentMethod';
import { MakeCall } from './createMakeCall';

const getPaymentMethods = (makeCall: MakeCall) => (userId: number) =>
  makeCall<PaymentMethod[]>('GET', `/api/v2/user/${userId}/payment-methods`);
export { getPaymentMethods };
